module.exports = __webpack_public_path__ + "img/train-10.dca64374.jpg";